import React from 'react';
import MaterialMenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';
import authHelper from 'helpers/auth';
import menuStructureSpecification, { adminSystemSpecification, ownerAccountAdminSpecification } from 'components/layout/Menu/index';
import translate from 'components/hoc/translate';
import { DashboardIcon, SettingsIcon } from 'assets/materialIcons/materialIcons';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import theme from 'theme/theme';

const StyledMenuItem = styled(MaterialMenuItem)`
    color: RGBA(255, 255, 255, 0.9) !important;
    border-radius: 4px;
    margin: 0 8px 4px 8px !important;
`;

const StyledSectionMenuItem = styled(MaterialMenuItem)`
    color: RGBA(255, 255, 255, 0.9) !important;
    min-height: auto !important;
    line-height: 20px !important;
    font-size: 14px !important;
    margin: 4px 8px 0 8px !important;
    padding: 4px 0 !important;
    border-radius: 4px;
`;

const iconStyle = {
    style: {
        fill: 'rgba(255, 255, 255, 0.7)',
    },
};

const innerSectionMenuItemStyle = {
    padding: '0 12px',
};

const StyledMenuSection = styled.div`
    margin: 20px 0 10px 0;
`;

const StyledSectionTitle = styled.h2`
    color: RGBA(255, 255, 255, 0.7);
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 700;
    padding: 0 20px 0;
    margin: 0 0 6px;
`;

const StyledNavLink = styled(NavLink)`
    &.sidebar__menu-item--active {
        background-color: ${ theme.palette.primary1Color2ColorHover } !important;
        color: #fff !important;
    }

    svg {
        fill: #fff !important;
    }

    svg path {
        stroke: #fff !important;
    }
`;

const innerMenuItemStyle = {
    padding: '0 16px 0 52px',
};

const generateResourceMenuItems = (resourceName, label, leftIcon, open, onMenuTap, translate) => {
    return (
        <StyledMenuItem
            key={ resourceName }
            containerElement={
                <StyledNavLink
                    exact
                    to={ `/${ resourceName }` }
                    activeClassName='sidebar__menu-item--active'
                    className='sidebar__menu-item'
                />
            }
            primaryText={ open ? translate(label) : '' }
            onTouchTap={ onMenuTap }
            leftIcon={ React.createElement(leftIcon, iconStyle) }
            innerDivStyle={ innerMenuItemStyle }
        />
    );
};

const Menu = (props) => {
    const { translate, onMenuTap, width, open } = props;

    const hasAccount = !!authHelper.getAccount();

    const role = hasAccount && authHelper.getUserRole();
    const isOwner = hasAccount && authHelper.isOwner();
    const isAdmin = hasAccount && authHelper.isAdmin();
    const menuStructure = menuStructureSpecification();
    const ownerSectionStructure = ownerAccountAdminSpecification();
    const adminSectionStructure = adminSystemSpecification();

    return (
        <div>
            <StyledMenuItem
                key='Dashboard'
                containerElement={
                    <StyledNavLink
                        exact
                        to='/'
                        activeClassName='sidebar__menu-item--active'
                        className='sidebar__menu-item'
                    />
                }
                primaryText={ open ? translate('menu.sidebar.dashboard') : '' }
                onTouchTap={ onMenuTap }
                leftIcon={ React.createElement(DashboardIcon, iconStyle) }
                innerDivStyle={ innerMenuItemStyle }
            />

            {
                role && menuStructure[role].map((menuItemObject) => {
                    return generateResourceMenuItems(
                        menuItemObject.resource,
                        menuItemObject.label,
                        menuItemObject.leftIcon,
                        open,
                        onMenuTap,
                        translate,
                    );
                })
            }

            { (role && isOwner) &&
            <StyledMenuSection>
                <StyledSectionTitle>{ translate('menu.sidebar.account_administration') }</StyledSectionTitle>

                {
                    ownerSectionStructure[role].map((menuItemObject) => {
                        return <StyledSectionMenuItem
                            key={ menuItemObject.resource }
                            containerElement={
                                <StyledNavLink
                                    exact
                                    to={ `/${ menuItemObject.resource }` }
                                    activeClassName='sidebar__menu-item--active'
                                    className='sidebar__menu-item'
                                />
                            }
                            innerDivStyle={ innerSectionMenuItemStyle }
                            primaryText={ open ? translate(menuItemObject.label) : '' }
                            onTouchTap={ onMenuTap }
                        />;
                    })
                }
            </StyledMenuSection>
            }

            { (role && isAdmin) &&
                <StyledMenuSection>
                    <StyledSectionTitle>{ translate('menu.sidebar.system_administration') }</StyledSectionTitle>

                    {
                        adminSectionStructure[role].map((menuItemObject) => {
                            if (menuItemObject.url) {
                                return <a style={ { textDecoration: 'none' } } href={ menuItemObject.url } key={ menuItemObject.resource }><StyledSectionMenuItem
                                    key={ menuItemObject.resource }
                                    containerElement={
                                        <div
                                            className='sidebar__menu-item'
                                        />
                                    }
                                    innerDivStyle={ innerSectionMenuItemStyle }
                                    primaryText={ open ? translate(menuItemObject.label) : '' }
                                    onTouchTap={ onMenuTap }
                                /></a>;
                            }
                            return <StyledSectionMenuItem
                                key={ menuItemObject.resource }
                                containerElement={
                                    <StyledNavLink
                                        exact
                                        to={ `/${ menuItemObject.resource }` }
                                        activeClassName='sidebar__menu-item--active'
                                        className='sidebar__menu-item'
                                    />
                                }
                                innerDivStyle={ innerSectionMenuItemStyle }
                                primaryText={ open ? translate(menuItemObject.label) : '' }
                                onTouchTap={ onMenuTap }
                            />;
                        })
                    }
                </StyledMenuSection>
            }

            {width === 1 && [
                'travel-provider',
                'publisher',
            ].indexOf(role) !== -1 ?
                <StyledMenuItem
                    key='Profile'
                    containerElement={
                        <StyledNavLink
                            to={ `/profile` }
                            activeClassName='sidebar__menu-item--active'
                        /> }
                    primaryText={ open ? translate('menu.topbar.profile') : '' }
                    onTouchTap={ onMenuTap }
                    leftIcon={ React.createElement(SettingsIcon) }
                    innerDivStyle={ innerMenuItemStyle }
                />
                :
                ''
            }
        </div>
    );
};

Menu.propTypes = {
    onMenuTap: PropTypes.func,
    open: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    width: PropTypes.number,
};

export default translate(Menu);



// WEBPACK FOOTER //
// ./src/components/menus/Menu/index.js